export const AGGREGATION_INTERVALS = [
    'DAY', 
    'WEEK', 
    'MONTH'
] 